import React from "react";

const ErrorPage = ({ msg }) => {
	return (
		<>
			<h1
				style={{
					display: "block",
					width: "100%",
					maxWidth: "1200px",
					margin: "0 auto",
					textAlign: "center",
					fontFamily: "calibri",
					color: "white",
					fontSize: "55px",
				}}
			>
				{msg}
			</h1>
		</>
	);
};

export default ErrorPage;
